import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap";
import FileUpload from "components/Common/file-upload/file-upload.component";
import { toast } from "react-toastify";
import CompoundService from "services/Admin/CompoundService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";

const MediaComponent = ({ compoundData, compoundId, setCompoundData }) => {
    const compoundService = new CompoundService()
    const [compound, setCompound] = useState({})
    const [mediaIds, setMediaIds] = useState([])
    const [videosIds, setVideosIds] = useState([])
    const [updateFlag, setUpdateFlag] = useState(false)

    useEffect(() => {
        setMediaIds([...compoundData.images_ids])
        setVideosIds([...compoundData.videos_ids])
        setCompound({ ...compoundData })
    }, [])

    useEffect(() => {
        if (updateFlag) {
            updateHandler()
        }
    }, [mediaIds, videosIds])

    const updatedAttachment = (attachments, type) => {
        if (type === "media_id") {
            setMediaIds([...mediaIds, ...attachments])
        } else {
            setVideosIds([...videosIds, ...attachments])
        }
        setUpdateFlag(true)
    };

    const deleteAttachment = (Items, type) => {
        if (type === "media_id") {
            let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
            setMediaIds(updatedMedia)
        } else {
            let updatedMedia = videosIds.filter(item => item.id != Items[0].id)
            setVideosIds(updatedMedia)
        }
        setUpdateFlag(true)
    };

    const updateHandler = () => {
        if (updateFlag) {
            const data = {
                ...compound,
                developer_id: compound ?.developer_id ?.value,
                area_id: compound ?.area_id ?.value,
                facilities_ids: compound ?.facilities_ids ?.map(item => item ?.value),
                images_ids: mediaIds ?.map(item => item ?.id),
                videos_ids: videosIds ?.map(item => item ?.id)
            }

            compoundService.update(compoundId, data).then(response => {
                if (response && response.status === SuccessCreated) {
                    toast.success("Compound has been updated")
                    setCompoundData({
                        ...compound,
                        images_ids: mediaIds,
                        videos_ids: videosIds
                    })

                }
            })
        }
    }

    return (
        <React.Fragment>
            <Card className="w-100 mt-4">
                <CardBody>
                    <Row className="d-flex justify-content-between">
                        <Col md={6}  >
                            <h5>Compound Image</h5>
                            <p>Images Related With The Compound</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FileUpload
                                accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                label=''
                                attachmentType='media_id'
                                attachmentData={mediaIds}
                                setUpload={()=> {}}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card >
            <Card className="w-100 mt-4">
                <CardBody>
                <Row className="d-flex justify-content-between">
                        <Col md={6}  >
                            <h5>Compound Video</h5>
                            <p>Promotional Video for The Compound</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FileUpload
                                accept='.mp4'
                                label=''
                                attachmentType='videos_id'
                                attachmentData={videosIds}
                                setUpload={()=> {}}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card >
        </React.Fragment >
    )
}
export default MediaComponent